import { useState, useEffect } from "react";
import axios from "axios";
import BirthdayTable from "../components/birthdayTable";
import Pagination from "../components/newpagination";
import Layout from "../containers/layout";
import Cookies from "js-cookie";
import * as XLSX from "xlsx";
import {
  Page,
  Card,
  Text,
  BlockStack,
  InlineStack,
  Button,
  TextField,
  Spinner,
  Box,
  Grid,
  Toast,
} from "@shopify/polaris";
import ExpertWorkShopTable from "../components/expertWorkShopTable";

const ExpertWorkShop = () => {
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState({ from: "", till: "" });
  const [notification, setNotification] = useState(null);
  const [isFiltered, setIsFiltered] = useState(false);
  const perPage = 50;
  const token = Cookies.get("token");
  const showNotification = (tone, title) => {
    setNotification({ tone, title });
    setTimeout(() => setNotification(null), 5000);
  };
  const fetchData = async (page = 1) => {
    try {
      setLoading(true);
      let url = "";
      let params = { page, limit: perPage };
      if (isFiltered) {
        url = "https://api.iplanet.one/expert-workshop/getall/filter";
        params.startDate = date.from;
        params.endDate = date.till;
      } else {
        url = "https://api.iplanet.one/expert-workshop/getall";
      }
      const res = await axios.get(url, {
        params,
        headers: { Authorization: token },
      });
      const data = Array.isArray(res?.data?.list || res?.data?.list)
        ? res?.data?.list || res?.data?.list
        : [];
      setProducts(data);
      setTotalPages(res?.data?.pagination?.totalPages || 1);
    } catch (err) {
      console.error(err);
      showNotification("critical", "Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, isFiltered]);

  const FilterHandler = () => {
    if (!date.from || !date.till) {
      showNotification("warning", "Please select both dates");
      return;
    }
    setCurrentPage(1);
    setIsFiltered(true);

    fetchData(1);
  };

  const clearFilter = () => {
    setDate({ from: "", till: "" });
    setIsFiltered(false);
    setCurrentPage(1);

    fetchData(1);
  };

  const handleDownload = () => {
    try {
      const formattedData = products.map((item) => {
        const { updatedAt, __v, ...rest } = item;

        const formattedItem = {};

        Object.keys(rest).forEach((key) => {
          let newKey = key;

          if (key === "_id") {
            newKey = "Reference No";
          } else {
            newKey = key
              .replace(/([A-Z])/g, " $1")
              .replace(/^./, (str) => str.toUpperCase());
          }

          formattedItem[newKey] = rest[key];
        });

        return formattedItem;
      });

      const worksheet = XLSX.utils.json_to_sheet(formattedData);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Expert Workshop");

      XLSX.writeFile(workbook, "_data.xlsx");

      showNotification("success", "Exported successfully");
    } catch (error) {
      showNotification("critical", "Export failed");
    }
  };

  return (
    <Layout>
      <Page fullWidth>
        <BlockStack gap="500">
          {notification && (
            <Toast
              content={notification.title}
              tone={notification.tone}
              onDismiss={() => setNotification(null)}
            />
          )}

          <Card>
            <BlockStack gap="400">
              <InlineStack align="space-between">
                <Text variant="headingLg">Expert Workshop</Text>
                <InlineStack gap="200">
                  <Button variant="primary" onClick={handleDownload}>
                    Export
                  </Button>
                  {isFiltered && (
                    <Button onClick={clearFilter}>Clear Filter</Button>
                  )}
                </InlineStack>
              </InlineStack>

              <Card background="bg-surface-secondary" rounded="300">
                <Box padding="400">
                  <Grid
                    columns={{ xs: 1, sm: 6, md: 12, lg: 12 }}
                    gap={{ xs: "400", md: "500" }}
                    gap="400"
                  >
                    <Grid.Cell columnSpan={{ xs: 1, md: 5, lg: 5 }}>
                      <TextField
                        label="From Date"
                        type="date"
                        value={date.from}
                        onChange={(val) => setDate({ ...date, from: val })}
                      />
                    </Grid.Cell>
                    <Grid.Cell columnSpan={{ xs: 1, md: 5, lg: 5 }}>
                      <TextField
                        label="Till Date"
                        type="date"
                        value={date.till}
                        onChange={(val) => setDate({ ...date, till: val })}
                      />
                    </Grid.Cell>
                    <Grid.Cell columnSpan={{ xs: 1, md: 2 }}>
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          alignItems: "flex-center",
                          paddingTop: "var(--p-space-600)",
                        }}
                      >
                        <Button
                          variant="primary"
                          onClick={FilterHandler}
                          loading={loading}
                          disabled={
                            loading ||
                            !date.from ||
                            !date.till ||
                            date.from > date.till
                          }
                          fullWidth
                        >
                          Filter
                        </Button>
                      </div>
                    </Grid.Cell>
                  </Grid>
                </Box>
              </Card>
            </BlockStack>
          </Card>
          <Card>
            {loading ? (
              <div style={{ padding: "120px 0", textAlign: "center" }}>
                <Spinner size="large" />
              </div>
            ) : (
              <BlockStack gap="400">
                <ExpertWorkShopTable
                  products={products}
                  indexing={currentPage}
                  perPage={perPage}
                />

                <div style={{ padding: "40px 0", textAlign: "center" }}>
                  <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages}
                  />
                </div>
              </BlockStack>
            )}
          </Card>
        </BlockStack>
      </Page>
    </Layout>
  );
};

export default ExpertWorkShop;
